import React, { SyntheticEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post } from '../../utils/axios';
import { withDashboard } from '../../hoc';
import BikeOwnershipForm from '../../components/bike-add-ownership-form';
import { useDispatch } from 'react-redux';
import { pushToast } from '../../actions/toast';
import { formatAxiosError } from '../../utils';

const AddBikeOwnershipPage = (): JSX.Element => {
  const [formProps, setFormProps] = useState({
    bikeId: '',
    customerId: '',
    purchaseDate: new Date().toISOString().split('T')[0]
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  function onSubmit(event: SyntheticEvent) {
    event.preventDefault();
    setSubmitting(true);
    post('/bike-ownership/add', formProps)
      .then(() => {
        setSubmitting(false);
        dispatch(
          pushToast({ headText: 'Success', bodyText: 'Action successful', variant: 'success' })
        );
        navigate(`/customers/${formProps.customerId}`);
      })
      .catch((error) => {
        setSubmitting(false);
        dispatch(
          pushToast({ headText: 'Error', bodyText: formatAxiosError(error), variant: 'error' })
        );
      });
  }

  function handleChange(event: React.FormEvent<HTMLInputElement>) {
    const { name, value } = event.currentTarget;
    setFormProps({
      ...formProps,
      [name]: value
    });
  }

  return (
    <div className="container">
      <div className="head-panel d-flex">
        <div className="head-left">
          <h1 className="page-title">Add Bike Owner</h1>
        </div>
        <div className="head-right"></div>
      </div>
      <BikeOwnershipForm
        submitting={submitting}
        onSubmit={onSubmit}
        handleChange={handleChange}
        formProps={formProps}
      ></BikeOwnershipForm>
    </div>
  );
};

export default withDashboard(AddBikeOwnershipPage);
